import { DataField } from './DataFieldBase';

export class DataFieldTextBox extends DataField<string> {
  controlType = 'textbox';
  type: string;

  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || '';
  }
}